import getLogger from '../debuggers/logger'

const logger = getLogger('SupabaseRequests')

export const RETRY_BEHAVIORS = {
  '5xx': '5XX_ERROR',
  idempotent: 'IDEMPOTENT_ERROR',
  network: 'NETWORK_ERROR'
}

/**
 * Makes request using the Axios API.
 *
 * Generate a caller with the following signature:
 *
 *  interface RequestCallerOptions {
 *    isPublic?: boolean;
 *    retries?: number;
 *    retryBehavior?: '5XX_ERROR' | 'IDEMPOTENT_ERROR' | 'NETWORK_ERROR';
 *    [key: string]: any;
 *  }
 *  interface RequestCallerResponse {
 *    data: object;
 *    headers: object;
 *    request: object;
 *    status: number;
 *  }
 *
 *  type RequestCaller = (url: string, options: RequestCallerOptions) => Promise<RequestCallerResponse>
 *
 * E.g.
 *  # Making a GET request with no retries.
 *  getJsonRequest('https://api.example.com/auth', { isPublic: true })
 *
 *  # Making a GET request with two retries at 5xx, network and idempotent errors (default when retries are set but retryBehavior doesn't).
 *  getJsonRequest('https://api.example.com/auth', { isPublic: true, retries: 2 })
 *
 *  # Making a POST request with two retries at only 5xx errors.
 *  postJsonRequest('https://api.example.com/auth', { isPublic: true, retries: 2, retryBehavior: '5XX_ERROR' })
 *
 *  # Making a GET request with two retries at only network errors.
 *  getJsonRequest('https://api.example.com/auth', { isPublic: true, retries: 2, retryBehavior: 'NETWORK_ERROR' })
 *
 *  # Making a GET request with two retries at only idempotent errors.
 *  getJsonRequest('https://api.example.com/auth', { isPublic: true, retries: 2, retryBehavior: 'IDEMPOTENT_ERROR' })
 */
export const makeRequest = async (callback, log = () => undefined) => {
  try {
    const result = await callback() // callback contiene la operación Supabase
    log(result)
    return {
      data: result.data,
      status: result.error ? 'error' : 'success',
      error: result.error || null
    }
  } catch (error) {
    logger.debug('SUPABASE REQUEST ERROR', { error })
    throw error
  }
}
